import { render, staticRenderFns } from "./edit_info.vue?vue&type=template&id=90a29a00&scoped=true&"
import script from "./edit_info.vue?vue&type=script&lang=js&"
export * from "./edit_info.vue?vue&type=script&lang=js&"
import style0 from "./edit_info.vue?vue&type=style&index=0&id=90a29a00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a29a00",
  null
  
)

export default component.exports